'use strict';

DoohApps
.directive('datepicker', ['$parse', function ($parse) {
    return function (scope, element, attrs, controller) {
        var ngModel = $parse(attrs.ngModel);
        $(function () {
            element.datepicker({
                inline: true,
                dateFormat: 'yy-mm-dd',
                changeMonth: attrs.$attr.validPastDate ? true : false,
                changeYear: attrs.$attr.validPastDate ? true : false,
                yearRange: attrs.$attr.validPastDate ? 'c-80:+0' : '',
                onSelect: function (dateText, inst) {
                    scope.$apply(function (scope) {
                        // Change binded variable
                        ngModel.assign(scope, dateText);
                    });
                }
            });
        });
    }
}])
.directive('datePicker', ['$parse', '$filter', function ($parse, $filter) {
    return {
        restrict: 'AE',
        scope: {
            defaultDate: '=?defaultDate',
            ngDisable: '=',
            useModel: '=',
            onChange: '&',
            name: '@'
        },
        replace: true,
        link: function (scope, element, attrs, controller) {
            if (scope.useModel) scope.defaultDate = $parse(attrs.ngModel)
            var date;
            var format = localStorage['ShortDateFormat'].replace(/d/g, 'D').replace(/y/g, 'Y');
            if (typeof scope.defaultDate == 'string') {
                var regex = /^([0-9]{4}-[0-9]{1,2}-[0-9]{1,2}(\s[0-9]{1,2}:[0-9]{2})?)$/;
                if (regex.test(scope.defaultDate)) {
                    var tmpDate = scope.defaultDate.split(' ');
                    date = new Date(tmpDate[0].split('-')[0], tmpDate[0].split('-')[1] - 1, tmpDate[0].split('-')[2]);
                }
                else {
                    var tmpDate = moment(scope.defaultDate, format).format('YYYY-MM-DD');
                    date = new Date(tmpDate.split('-')[0], tmpDate.split('-')[1] - 1, tmpDate.split('-')[2]);
                }
            }
            else if (typeof scope.defaultDate == 'undefined' || scope.defaultDate == null) {
                date = new Date();
            }
            else date = new Date(scope.defaultDate);

            var day = (date.getDate() < 10) ? '0' + date.getDate() : date.getDate();
            var month = (date.getMonth() < 9) ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
            var year = date.getFullYear();
            var date2 = $filter('date')(date, localStorage['ShortDateFormat']);

            if (isNaN(date.getTime())) date2 = undefined;

            if ('datePicker' in attrs && attrs.datePicker == 'input') {
                element.val(date2).datetimepicker({
                    defaultDate: date2, timepicker: false, format: format,
                    onSelectDate: function (ct, $i) {
                        $i.datetimepicker('hide');
                        scope.$apply(function (scope) {
                            SetDate(ct);
                        });
                    },
                    onChangeDateTime: function (ct, $i) {
                        scope.$apply(function (scope) {
                            SetDate(ct);
                        });
                    }
                });
            }
            else {
                var txt = '<input name="' + scope.name + '"' + (scope.ngDisable == true ? ' disabled ' : '') + 'type="text" maxlength="10" class="ui-corner-all" />';
                jQuery(txt).val(date2).appendTo(element).datetimepicker({
                    defaultDate: date2, timepicker: false, format: format,
                    onSelectDate: function (ct, $i) {
                        $i.datetimepicker('hide');
                        scope.$apply(function (scope) {
                            SetDate(ct);
                        });
                    },
                    onChangeDateTime: function (ct, $i) {
                        scope.$apply(function (scope) {
                            SetDate(ct);
                        });
                    }
                });
            }

            function SetDate(ct) {
                if (ct != null) {
                    day = (ct.getDate() < 10) ? '0' + ct.getDate() : ct.getDate();
                    month = (ct.getMonth() < 9) ? '0' + (ct.getMonth() + 1) : (ct.getMonth() + 1);
                    year = ct.getFullYear();
                    var date = $filter('date')(ct, localStorage['ShortDateFormat']);
                }

                if (scope.useModel) {
                    scope.defaultDate = date;
                } else {
                    //for calculations use format YYYY-MM-DD
                    scope.defaultDate = year + '-' + month + '-' + day;//date;

                    //for display use user set format
                    $('input[name=' + scope.name + ']').val(date);
                }
            }

            scope.$watch(function () { return scope.defaultDate }, function (newValue, oldValue) {
                scope.defaultDate = newValue;
                scope.onChange();
            });

            scope.$watch(function () { return scope.ngDisable }, function (newValue, oldValue) {
                var input = jQuery(element).first().children()[0];
                $(input).prop('disabled', scope.ngDisable);
            });
        }
    }
}]);